import React from "react";
import css from "./PluginsIntro.module.css";
import {Badge,NoticeView,Title} from "Components";


export default function PluginsIntro(props){
    const {}=props;
    return (
        <div className={`${css.pluginsintro} ${props.className||""}`}>
            <Title>supported cordova platforms</Title>
            <ul className={css.platforms}>
                {statics.platfoms.map(({id,label})=>(
                    <li key={id}>
                        <span className={css.name}>Cordova-{id}</span>
                        {label&&<Badge text={label}/>}
                    </li>
                ))}
            </ul>
            <NoticeView text={`
                For Android, all plugins were tested using cordova-android version <b>10.1.2</b>,
                so using that version is recommended
            `}/>
        </div>
    )
}

const statics={
    platfoms:[
        {id:"android",label:"^10.1.2"},
        {id:"iOS",label:"^7.0.0"},
        {
            id:"browser",
            label:"dev only",
        },
    ],
}
